module.exports = __webpack_public_path__ + "img/mercator-tex.9c91663e.jpg";